import type { FC } from "react";

import { RedirectionLinkCard } from "@ui/components/RedirectionLinkCard";
import { useCurrentBreakpoint } from "@ui/hooks/useCurrentBreakpoint";

import { ImageBehaviour } from "@jti/core-components/components/ImageBehaviour";
import { LinkBehaviour } from "@jti/core-components/components/LinkBehaviour";
import { dispatchTrackingEvent, TrackingEvents } from "@jti/tracker";

import styles from "./SimpleProductTeaser.module.scss";

export type SimpleProductTeaserProps = {
  name: string;
  src: string;
  alt: string;
  link: {
    href: string;
    text: string;
  };
};

export const SimpleProductTeaser: FC<SimpleProductTeaserProps> = ({ name, src, link, alt }) => {
  const { specificBreakpoint } = useCurrentBreakpoint();
  const isMobile = ["small", "xSmall", "smallMedium", "smallLarge"].includes(specificBreakpoint);

  const dispatchGTMEvent = () => {
    dispatchTrackingEvent(TrackingEvents.TrackingMenuNavigationListClick);
  };

  return (
    <div>
      {isMobile ? (
        <RedirectionLinkCard
          title={name}
          link={link.href}
          variant="withImage"
          image={src}
          className={styles.mobileVariant}
        />
      ) : (
        <div className={styles.item} data-testid="simple-product-teaser" onClick={dispatchGTMEvent}>
          <LinkBehaviour href={link.href}>
            <>
              <div className={styles.title}>{name}</div>
              <div className={styles.imageContainer}>
                <ImageBehaviour src={src} alt={alt} className={styles.image} />
              </div>
              <div className={styles.link}>{link.text}</div>
            </>
          </LinkBehaviour>
        </div>
      )}
    </div>
  );
};
